// extracted by mini-css-extract-plugin
module.exports = {"buttonColor":"ButtonTransparent_buttonColor__naIXx","buttonSize":"ButtonTransparent_buttonSize__7LM2h","buttonPadding":"ButtonTransparent_buttonPadding__CWidH"};